import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router';
import { MasterMobileRoot } from '@/mobile/master';
import { useAuth } from '@/lib/auth';

export const Route = createFileRoute('/m/master')({
  component: MasterMobileLayout,
});

function MasterMobileLayout() {
  const { user, loading, isPlatform, isImpersonating } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          height: '100dvh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--bg)',
        }}
      >
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13, color: 'var(--fg-muted)' }}>
          Carregando…
        </span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Impersonando → cair na visão mobile do workspace (banner trata o retorno)
  if (isImpersonating) {
    return <Navigate to="/m" replace />;
  }

  // Apenas plataforma acessa o Master mobile
  if (!isPlatform) {
    return <Navigate to="/m" replace />;
  }

  return (
    <MasterMobileRoot>
      <Outlet />
    </MasterMobileRoot>
  );
}
